import { StyleSheet } from '@react-pdf/renderer';

// PDF styles for react-pdf renderer
export const pdfStyles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    fontFamily: 'Montserrat',
    padding: 0,
  },
  container: {
    width: '100%',
    backgroundColor: '#ffffff',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12 16',
    backgroundColor: '#1e40af',
    position: 'relative',
    overflow: 'hidden',
  },
  headerLeft: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 24,
  },
  logoBox: {
    padding: '0',
    borderRadius: 4,
    width: 54,
    height: 54,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 4,
  },
  logoText: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#1e40af',
    letterSpacing: 0.5,
  },
  headerRight: {
    alignItems: 'center',
  },
  dateBadge: {
    backgroundColor: '#00b3c7',
    padding: '8 16',
    borderRadius: 16,
  },
  dateBadgeText: {
    fontSize: 12,
    fontWeight: 600,
    color: '#ffffff',
    letterSpacing: 0.5,
  },
  mainContent: {
    padding: "20px 20px 0 20px",
    flexDirection: 'column',
    gap: 16,
  },
  splitContent: {
    flexDirection: 'row',
    gap: 24,
  },
  leftColumn: {
    flex: 1,
    flexDirection: 'column',
    gap: 24,
  },
  rightColumn: {
    width: 225,
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#121f2b',
    marginBottom: 8,
    lineHeight: 1.2,
  },
  subtitle: {
    fontSize: 11,
    color: '#00393d',
    lineHeight: 1.2,
    maxWidth: 600,
  },
  card: {
    border: '1px solid #f3f4f6',
    borderRadius: 16,
  },
  /**
   * Continuation of Monatskommentar on the next page.
   * mainContent paddingTop only applies on page 1 of a wrapping View — add explicit
   * top inset here so text is not flush with the page edge. Full borderRadius so the
   * card top is rounded (page-1 card keeps its bottom radius).
   */
  commentaryCardContinued: {
    border: '1px solid #f3f4f6',
    borderRadius: 16,
    marginTop: 20,
    paddingTop: 4,
  },
  cardHeader: {
    padding: '8 12',
    borderBottom: '1px solid #f3f4f6',
  },
  blueCard: {
    flex: 1,
    border: '0px'
  },
  blueCardHeader: {
    backgroundColor: '#00b3c7',
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    borderBottom: '0px'
  },
  blueCardBody: { border: '1px solid #f3f4f6', borderTop: '0px', borderBottomLeftRadius: 16, borderBottomRightRadius: 16 },
  cardHeaderTitle: {
    fontWeight: 'bold',
    fontSize: 12,
    color: '#111827',
  },
  colorWhite: {
    color: '#fff',
  },
  cardBody: {
    padding: 16,
  },
  cardBodyText: {
    fontSize: 10,
    color: '#374151',
  },
  bulletItem: {
    flexDirection: 'row',
    gap: 8,
  },
  bulletPoint: {
    fontSize: 12,
    color: '#6b7280',
    fontWeight: 'bold',
    minWidth: 12,
  },
  bulletText: {
    fontSize: 10,
    color: '#6b7280',
    lineHeight: 1.5,
    flex: 1,
  },
  legalKvRow: {
    flexDirection: 'row',
    marginBottom: 8,
    gap: 8,
  },
  legalKvLabel: {
    fontSize: 10,
    color: '#111827',
    fontWeight: 'bold',
  },
  legalKvValue: {
    fontSize: 10,
    color: '#374151',
    flex: 1,
  },
  legalText: {
    fontSize: 10,
    color: '#374151',
    lineHeight: 1.5,
  },
  legalSeparator: {
    width: '100%',
    height: 1,
    backgroundColor: '#000000',
    marginTop: 12,
    marginBottom: 12,
  },
  chartPlaceholder: {
    width: '100%',
    minHeight: 200,
    border: '2px dashed #cbd5e1',
    borderRadius: 16,
    backgroundColor: '#f8fafc',
    padding: 12,
    alignItems: 'center',
    justifyContent: 'center',
  },
  chartContainer: {
    width: '100%',
    borderRadius: 12,
    overflow: 'hidden'
  },
  placeholderText: {
    fontSize: 16,
    color: '#64748b',
    textAlign: 'center',
  },
  noticeBox: {
    width: '100%',
    minHeight: 140,
    borderRadius: 16,
    backgroundColor: '#f8fafc',
    padding: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },
  noticeText: {
    fontSize: 11,
    lineHeight: 1.4,
    color: '#1f2937',
    textAlign: 'center',
    maxWidth: 380,
  },
  noticeInline: {
    fontSize: 8,
    lineHeight: 1.4,
    color: '#1f2937',
    marginTop: 6,
  },
  fundManagerSection: {
    flexDirection: 'column',
    gap: 16,
    borderTop: '1px solid #f3f4f6',
    padding: 16,
  },
  fundManagerContent: {
    flexDirection: 'row',
    gap: 16,
    alignItems: 'flex-start',
  },
  fundManagerPhoto: {
    width: 80,
    height: 80,
    borderRadius: 12,
    border: '2px solid #e5e7eb',
    objectFit: 'cover',
    objectPosition: 'left',
  },
  fundManagerPhotoPlaceholder: {
    width: 132,
    height: 132,
    borderRadius: 16,
    backgroundColor: '#e5e7eb',
    border: '2px solid #cbd5e1',
  },
  fundManagerInfo: {
    flex: 1,
    flexDirection: 'column',
  },
  fundManagerName: {
    fontSize: 11        ,
    fontWeight: 'bold',
    color: '#121f2b',
  },
  fundManagerCompany: {
    fontSize: 10,
    color: '#003C50',
    lineHeight: 1.2,
  },
  fundManagerResearch: {
    fontSize: 10,
    color: '#003C50',
    lineHeight: 1.2,
  },
  fundManagerCompany2: {
    fontSize: 10,
    color: '#003C50',
    lineHeight: 1.2,
  },
  fundManagerPhone: {
    fontSize: 10,
    color: '#003C50',
    lineHeight: 1.2,
  },
  hedgingButton: {
    backgroundColor: '#00b3c7',
    padding: '2px 8px',
    borderRadius: 16,
    marginTop: 2,
    alignSelf: 'flex-start',
  },
  hedgingButtonText: {
    fontSize: 9,
    fontWeight: 'bold',
    color: '#ffffff',
  },
  commentaryText: {
    fontSize: 10,
    color: '#00393d',
    lineHeight: 1.2,
  },
  commentaryParagraph: {
    marginBottom: 8,
  },
  sidebar: {
    backgroundColor: '#002e3d',
    borderRadius: 12,
    padding: '16',
  },
  sidebarSection: {
    marginBottom: 24,
  },
  sidebarSectionTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#ffffff',
    marginBottom: 8,
    letterSpacing: 0.5,
  },
  kvGroup: {
    flexDirection: 'column',
  },
  kvRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 6,
  },
  kvLabel: {
    fontSize: 10,
    color: '#ffffffcc',
    lineHeight: 1,
  },
  kvValue: {
    fontSize: 10,
    color: '#ffffff',
    fontWeight: 500,
    textAlign: 'right',
    lineHeight: 1.2,
  },
  kvWidth30: {
    maxWidth: '30%',
  },
  kvWidth70: {
    maxWidth: '70%',
  },
  chartSectionContainer: {
    width: '100%',
    height: 200,
  },
  performanceTable: {
    width: '100%',
  },
  performanceTableHeader: {
    flexDirection: 'row',
    backgroundColor: '#f3f4f6',
    borderBottom: '1px solid #e5e7eb',
  },
  performanceTableHeaderCell: {
    flex: 1,
    padding: '8 12',
  },
  performanceTableHeaderText: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#111827',
    textAlign: 'center',
  },
  performanceTableRow: {
    flexDirection: 'row',
    backgroundColor: '#ffffff',
  },
  performanceTableCell: {
    flex: 1,
    padding: '8 12',
  },
  performanceTableValue: {
    fontSize: 10,
    color: '#111827',
    textAlign: 'center',
  },
  explanatoryText: {
    marginTop: 24,
    paddingTop: 24,
    borderTop: '1px solid #e5e7eb',
  },
  explanatoryTextTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#111827',
    marginBottom: 12,
  },
  explanatoryTextContent: {
    fontSize: 11,
    color: '#00393d',
    lineHeight: 1.6,
    marginBottom: 8,
  },
  twoColumn: {
    display: 'flex',
    flexDirection: 'row',
    gap: 16,
  },
  twoColumnSection: {
    flex: 1,
  },
  strategyCard: {
    flex: 1,
    backgroundColor: '#ffffff',
    borderRadius: 8,
    padding: 0,
    marginRight: 8,
  },
  awardsCard: {
    flex: 1,
    backgroundColor: '#ffffff',
    borderRadius: 8,
    padding: 0,
    flexDirection: 'column',
    marginLeft: 8,
  },
  strategyText: {
    fontSize: 11,
    color: '#00393d',
    lineHeight: 1.4,
  },
  awardPlaceholderContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 'auto'
  },
  awardPlaceholder: {
    backgroundColor: '#f3f4f6',
    borderRadius: 8,
    marginBottom: 12,
    alignItems: 'center',
    justifyContent: 'center',
    height: 80,
    width: 80,
  },
  awardPlaceholderText: {
    fontSize: 14,
    color: '#9ca3af',
    fontWeight: 'bold',
  },
  awardPlaceholderLabel: {
    fontSize: 10,
    color: '#00393d',
    textAlign: 'center',
    width: 120
  },
  mt4: {
    marginTop: 4
  },
  mt8: {
    marginTop: 8
  },
  w60: {
    width: '60%',
  },
  w70: {
    width: '70%',
  },
  fourCardGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    width: '100%',
  },
  allocationCard: {
    width: '48%',
    marginRight: '2%',
  },
  stockList: {
    flexDirection: 'column',
  },
  stockListItem: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: '4 0',
  },
  stockListNumber: {
    fontSize: 10,
    color: '#111827',
    fontWeight: 'bold',
    width: 20,
  },
  stockListName: {
    fontSize: 10,
    color: '#111827',
    flex: 1,
  },
  allocationFallbackList: {
    width: '100%',
    alignSelf: 'stretch',
    flexDirection: 'column',
    paddingHorizontal: 6,
  },
  allocationFallbackRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 3,
    borderBottom: '1px solid #f3f4f6',
  },
  allocationFallbackLabel: {
    fontSize: 9,
    color: '#111827',
    flexShrink: 1,
    paddingRight: 8,
  },
  allocationFallbackValue: {
    fontSize: 9,
    color: '#111827',
    fontWeight: 'bold',
    minWidth: 48,
    textAlign: 'right',
  },
  stockListPercentage: {
    fontSize: 10,
    color: '#111827',
    fontWeight: 'bold',
    width: 50,
    textAlign: 'right',
  },
  threePanelGrid: {
    flexDirection: 'row',
    width: '100%',
    gap: 16,
  },
  infoPanel: {
    flex: 1,
    marginRight: 8,
    backgroundColor: '#ffffff',
    padding: 0,
  },
  infoPanelHeader: {
    backgroundColor: '#00b3c7',
    borderRadius: 8,
    padding: '12 16',
  },
  infoPanelTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#ffffff',
    textAlign: 'center',
  },
  infoPanelBody: {
    padding: 16,
  },
  infoPanelText: {
    fontSize: 10,
    color: '#111827',
    lineHeight: 1.6,
  },
  riskScaleLabels: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  riskScaleLabel: {
    fontSize: 8,
    color: '#111827',
    fontWeight: 'bold',
    width: 50
  },
  riskScaleBoxes: {
    flexDirection: 'row',
    gap: 4,
    marginBottom: 8,
    justifyContent: 'center',
  },
  riskScaleBox: {
    width: 28,
    height: 20,
    borderRadius: 4,
    backgroundColor: '#e5e7eb',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #d1d5db',
  },
  riskScaleBoxActive: {
    backgroundColor: '#00b3c7',
    border: '1px solid #00b3c7',
  },
  riskScaleBoxNumber: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#374151',
  },
  riskScaleBoxNumberActive: {
    color: '#ffffff',
  },
  riskGradientBar: {
    height: 6,
    backgroundColor: '#00b3c7',
    marginBottom: 8,
    position: 'relative',
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 16,
  },
  riskGradientBarInner: {
    flex: 1,
    height: '100%',
  },
  riskGradientArrow: {
    position: 'absolute',
    right: -6,
    fontSize: 10,
    color: '#00b3c7',
  },
  riskDisclaimerText: {
    fontSize: 8,
    color: '#6b7280',
    lineHeight: 1.5,
    marginTop: 8,
    // fontStyle: 'italic',
  },
  piechartSectionContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  alignCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

